<script>
import axios from "axios";
import {challenge} from "@/services/recaptcha";

export default {
  name: "order",
  render: () => null,
  data() {
    return {
      order: null,
      transaction_type: null,
      input: null
    };
  },
  methods: {
    async createOrder(transaction_type, input) {
      this.transaction_type = transaction_type;
      this.input            = input;

      const payment_form_id   = input.method_payment.paymentForm.payment_form_id;
      const body              = input.body;
      const confirmation_type = this.getConfirmationType(payment_form_id);
      const paymentFormBody   = await this.handlePaymentFormBody(payment_form_id, input.method_payment);
      const {data}            = await axios.post('/api/v2/order', {
        transaction_type,
        confirmation_type,
        hold: true,
        payment_form_input: [
          {
            payment_form_id,
            ...paymentFormBody,
          }
        ],
        ...body,
      });
      this.order              = data;
      return data;
    },
    async preConfirmOrder() {
      const payment_form_id = this.input.method_payment.paymentForm.payment_form_id;

      const paymentFormBody = await this.handlePaymentFormBody(payment_form_id, this.input.method_payment);

      const {data} = await axios
          .put(`/api/v2/order/${this.order.id}`, {
            payment_form_input: [
              {...paymentFormBody},
            ],
          });
      this.order   = data;
      return data
    },
    async confirmOrder() {
      const payment_form_id = this.input.method_payment.paymentForm.payment_form_id;

      const paymentFormBody = await this.handlePaymentFormBody(payment_form_id, this.input.method_payment, true);

      const {data} = await axios
          .put(`/api/v2/order/${this.order.id}/confirm`, {
            payments: [
              {...paymentFormBody},
            ],
          });
      this.order   = data;
      return data
    },
    getConfirmationType(paymentFormId) {
      switch (paymentFormId) {
        case 3:
          return 2;
        case 5:
          return 4;
        case 10:
          return 9;
        case 11:
          return 7;
        default:
          return 5;
      }
    },
    async handlePaymentFormBody(paymentFormId, paymentFormBody, willConfirmOrder = false) {
      switch (paymentFormId) {
        case 2:
        case 3:
          return await this.handleCardObj(paymentFormBody.card, willConfirmOrder);
        case 5:
          await this.updateAddress(paymentFormBody.boleto);
          return {};
        default:
          return {};

      }
    },
    async updateAddress(fullAddressObj) {
      let address = `${fullAddressObj.address},${fullAddressObj.number}`
      if (fullAddressObj.complement) {
        address += `,${fullAddressObj.complement}`
      }

      let address_obj = {
        address,
        district: fullAddressObj.district,
        city: fullAddressObj.city,
        uf: fullAddressObj.uf,
        cep: fullAddressObj.cep.replace(/[^0-9]/g, ''),
      }

      const original_address = await axios.get('/api/user').then(res => {
        if (res.data.address) {
          return address = JSON.parse(res.data.address);
        }
        return {};
      });

      if (
          original_address.address !== address_obj.address ||
          original_address.cep !== address_obj.cep ||
          original_address.city !== address_obj.city ||
          original_address.district !== address_obj.district ||
          original_address.uf !== address_obj.uf
      ) {
        await axios.put("/api/users/me/address/change", {address: address_obj});
      }
    },
    async handleCardObj(card, willConfirmOrder) {
      const payment_form_id = this.input.method_payment.paymentForm.payment_form_id;


      if (willConfirmOrder && this.order.extra && this.order.extra.encryptionInput) {
        // eslint-disable-next-line no-undef
        const data = PagSeguro.encryptCard({
          publicKey: this.order.extra.encryptionInput.public_key,
          holder: card.card_holder,
          number: `${card.number.replace(/[^0-9]/g, '')}`,
          expMonth: `${card.valid_month.split("/")[0]}`,
          expYear: `20${card.valid_month.split("/")[1]}`,
          securityCode: `${card.ccv}`,
        });

        if (data.hasError) {
          throw new Error(data.errors[0])
        }

        card.encrypted_token = data.encryptedCard;
      }

      let recaptcha = undefined
      if (willConfirmOrder) {
        recaptcha = await challenge();
      }

      return {
        card: {
          ...card,
          number: card.number.replace(/[^0-9]/g, ''),
          valid_month: card.valid_month.split("/")[0],
          valid_year: card.valid_month.split("/")[1],
          type: payment_form_id,
        },
        recaptcha,
      }
    }
  },
}
</script>


